export default __webpack_public_path__ + "static/media/mercy.626b737e.png";